import {  useContext, useEffect, useReducer, useState } from "react"
import { Modal } from "react-bootstrap"
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion"
import { GetSinRetorno, Post2, PostSinContent } from "../Rutas/ApiRest"
import { VendemosContigo, cuentaCliente } from "../Rutas/Servicios"
import { tokens } from "../Context/Tokens"
import { Contexto } from "../Context/Contexto"

export function Modelos()
{
    const [activo,SetActivo]=useState<boolean>()
    const {MensajeEmergente,SetMensajeEmergente}=useContext(MensajeContActualizacion)

    const key=(e:any)=>
    {
      if (e.key === 'Enter') {
        desactivar()
      }
    }
    useEffect(()=>
    {
        if(MensajeEmergente!="")
        {
            SetActivo(true)
        }
    })

    const desactivar=()=>
    {
        SetActivo(false);
        SetMensajeEmergente("");
    }
    return (
    <>
    
    <Modal show={activo} tabIndex={0} onKeyDown={key}>
        
        <Modal.Body style={{borderColor:"#bce8f1"}}>
            <div className="panel panel-info" style={{padding:"10px 15px",borderBottom:"1px solid trasparent",borderTopRightRadius:"3px",borderTopLeftRadius:"3px",color:"#31708f",backgroundColor:"#d9edf7",borderColor:"#bce8f1"}}>
                <label style={{display:"inline-block",marginBottom:"5px",fontWeight:"700"}}>
                    {MensajeEmergente}
                </label>
            </div>
            
        </Modal.Body>
        <Modal.Header style={{marginBottom:"20px",padding:"10px 15px",color:"#31708f",backgroundColor:"#fff",borderColor:"#bce8f1",border:"1px solid transparent",borderRadius:"4px",display:"block"}}>
            
        </Modal.Header >
        <Modal.Footer>
            <button className="btn btn-warning"  onClick={()=>desactivar()}>Cerrar</button>
        </Modal.Footer>
    </Modal>
   
    </>)
}

export function Calculadora()
{
    const [activo1,SetActivo1]=useState<boolean>()
    const {CasillaCalculadora,SetCasillaCalculadora}=useContext(MensajeContActualizacion)
    const [li,Setli]=useState<any>()

    useEffect(()=>
    {
        if(CasillaCalculadora!="")
        {
            switch(CasillaCalculadora)
            {
                case"Casilla Ebay":{Setli(<>
                <li>No hay costo por registro ni de renovación</li>
                <li>Hasta 2 meses de almacenaje gratis en Miami</li>
                <li>Seguro de carga de hasta US$500 por envío</li>
                <li>Tarifa especial de transporte<a href="https://eshopex.cl/ebay/#ppplan_price" target="_blank" rel="noopener noreferrer"> Más detalles</a></li>
                </>
                    )}
                break;
                case"Casilla Amazon":{Setli(<>
                    <li>No hay costo por registro ni de renovación</li>
                    <li>Hasta 2 meses de almacenaje gratis en Miami</li>
                    <li>Seguro de carga de hasta US$500 por envío</li>
                    <li>Tarifa especial de transporte<a href="https://eshopex.cl/amazon/" target="_blank" rel="noopener noreferrer"> Más detalles</a></li>
                    </>
                        )}
                break;
                case"Casilla Gratis":{Setli(<>
                    <li>No hay costo por registro ni de renovación</li>
                    <li>Hasta 2 meses de almacenaje gratis en Miami</li>
                    <li>Seguro de carga de hasta US$500 por envío</li>
                    </>
                        )}
                break;
                case"Carga peligrosa":{Setli(<>
                    <li>Para más información de cargas peligrosas haga click <a href="https://eshopex.cl/productos-restringidos/" target="_blank" rel="noopener noreferrer">Aquí</a></li>
                    </>
                        )}
                break;
                case"Casilla Espana":{Setli(<>
                    <li>Para más información de Casilla España haga click <a href="https://eshopex.cl/casilla-europa/" target="_blank" rel="noopener noreferrer">Aquí</a></li>
                    </>
                        )}
                break;
            }
            SetActivo1(true)
        }
    },[CasillaCalculadora])

    const desactivar=()=>
    {
        SetActivo1(false);
        SetCasillaCalculadora("");
        Setli("")
    }
    return (
    <>
    
    <Modal show={activo1} >
        
        <Modal.Header >
        <div className="panel panel-info" >
                <label >
                    {CasillaCalculadora}
                </label>
            </div>
        </Modal.Header >

        <Modal.Body >
            <div className="panel panel-info" >
                <label >
                    <ul>
                        {li}
                    </ul>
                </label>
            </div>
            
        </Modal.Body>
       
        <Modal.Footer>
            <button className="btn btn-primary" onClick={()=>desactivar()}>Cerrar</button>
        </Modal.Footer>
    </Modal>
   
    </>)
}

export function Loading()
{
    const {Loadings}=useContext(MensajeContActualizacion)
    return (
    
    <Modal show={Loadings} style={{top:"35%",border:"1px solid transparent"}}>
        
            <div className="spinner-box">
                            <div className="loading-icon">
                            </div>
                            <span>Loading...</span>
                            </div>
        
     
    </Modal>
   
    
    )
}
export function Loading2()
{
    const {Loading2,Loadings}=useContext(MensajeContActualizacion)
    
       
    return (
    
    <Modal show={!Loadings&&!Loading2?false:true} style={{top:"35%",border:"1px solid transparent"}}>
        
            <div className="spinner-box">
                            <div className="loading-icon">
                            </div>
                            <span>Loading...</span>
                            </div>
        
     
    </Modal>
   
    
    )
}

export function ActivarEspana()
{
    const [activo,SetActivo]=useState<boolean>(true)
    const desactivar=()=>
    {
        SetActivo(false);
    }
    return(
        <Modal show={activo} >
        
        <Modal.Header >
        <div className="panel panel-info" >
                <label >
                    Casilla España
                </label>
            </div>
        </Modal.Header >

        <Modal.Body >
            <div className="panel panel-info" >
                <label >
                     ¿Está seguro que Deses Activar su Casilla?
                </label>
            </div>
            
        </Modal.Body>
       
        <Modal.Footer>
            <button className="btn btn-primary" >Aceptar</button>
            <button className="btn btn-primary" onClick={()=>desactivar()}>Cerrar</button>
        </Modal.Footer>
    </Modal>
    )
}

export function PreAlertaEspana()
{
    const {tok}=useContext(tokens)
    const {SetMensajeEmergente,SetLoading,ActivoPreAlerta,SetActivoPreAlerta,CambiosCantidad,SetCambiosCantidad}=useContext(MensajeContActualizacion)
    const {Cli}=useContext(Contexto)
    const [Url,SetUrl]=useState<string>("")
    const extension1='.jpg'
    const extension2='.pdf'
    const extension3='.png'
    const [state,dispatch]=useReducer(reducer,{tracking:"",tienda:"",valor:0,descripcion:""})
    const SubirFactura=(e:any)=>
    {
        SetLoading(true);  
      var files = e.target.files[0]

        if(files.size<=4194304)
        {
            if(files.name.includes(extension1) || files.name.includes(extension2) || files.name.includes(extension3))
            {
                
                  var formdata = new FormData();
                  formdata.append("", files, files.name);

                  const dato3=PostSinContent(cuentaCliente.SubirImagen,formdata,tok)
                            dato3.then(resultado=>{
                                SetUrl(resultado)
                                SetLoading(false);
                              })
            }else
            {
                SetUrl("")
                SetMensajeEmergente("Ingrese una factura con los formatos requeridos")
            }
        }
        else
        {
            SetUrl("")
            SetMensajeEmergente("Tamaño del Archivo es mayor a 4MB ")
        }
        SetLoading(false);

    }
    function cambio(event:any)
    {

        dispatch({type:"cambio",input:{
        name:event.target.name,
        value:event.target.value
      }})
    }
    function reducer(state:any,action:any)
    {
      switch(action.type)
      {
        
        case "cambio":return {
          ...state,[action.input.name]:action.input.value
        }
        case "Reinicio":
          {
            SetActivoPreAlerta(false)
            return {tracking:"",tienda:"",valor:0,descripcion:""}
        }
          
         
      }
    
      return state;
    }
    const Aceptar=()=>
    {
        
        if(Validador())
        {
            
            SetLoading(true);
            
            var body={
                "alr_guimia": state.tracking,
                "alr_comentario": state.descripcion,
                "alr_casillero": Cli.lCasilla[Cli.Eleccion].ecode,
                "alr_tienda": state.tienda,
                "alr_valor": state.valor,
                "alr_seguro": true,
                "alr_direccion": Url
              }
               
              const PreAlerta=Post2(cuentaCliente.PreAlerta,JSON.stringify(body),"application/json",tok)
              
              PreAlerta.then(resultado2=>{SetMensajeEmergente(resultado2);SetLoading(false);SetCambiosCantidad(CambiosCantidad+1)})
              dispatch({type:"Reinicio"})
              
              SetUrl("");
        }else
        {
            SetMensajeEmergente("Debe completar todo los datos")
        }
        
    }


    const Validador=()=>
    {

        if(state.tracking=="")
        {
            return false;
        }
        if(state.tienda=="")
        {
            return false;
        }
        if(state.valor<=0)
        {
            return false;
        }
        if(state.descripcion=="")
        {
            return false;
        }
        if(Url=="")
        {
            return false;
        }

        return true;
    }
    return(
        <Modal show={ActivoPreAlerta} >
        
        <Modal.Header >
        <div className="panel panel-info" style={{fontSize:"20px"}}>
                <label >
                    Prealerta de paquetes
                </label>
            </div>
        </Modal.Header >

        <Modal.Body >
            
            
                    <div className="card-body">
                      
                        <div className="col-12">
                            <div>
                                <label className="form-label">
                                    No. de Tracking*
                                </label>
                                
                                <input className="col-12 col-m-8" value={state.tracking} onChange={cambio}  name="tracking" ></input>
                            </div>
                            <hr></hr>
                            <div>
                                <label className="form-label">
                                    Tienda donde compraste el producto*
                                </label>
                                
                                <input className="col-12 col-m-8" value={state.tienda} onChange={cambio} name="tienda" ></input>
                            </div>
                            <hr></hr>
                            <div>
                                <label className="form-label">
                                    Valor total de su compra*
                                </label>
                                <input className="col-12 col-m-8" value={state.valor} onChange={cambio} name="valor" type="number"></input>
                            </div>
                            <hr></hr>
                            <div>
                                <label className="form-label">
                                    Descripcion del producto*
                                </label>
                                <input className="col-12 col-m-8" value={state.descripcion} onChange={cambio} name="descripcion" ></input>
                            </div>
                            <hr></hr>
                            <div>
                                <label className="form-label">
                                    Subir factura relacionada a esta compra*
                                </label>
                                <p style={{fontSize:"80%",color:"red"}}>PDF, JPG o PNG. Tamaño max. 4MB. Si su paquete tiene más de una factura debe ponerlas todas en un solo archivo PDF.</p>
                                <input type="file" onChange={SubirFactura}/>
                            </div>
                    </div>
                      
                    </div>
            
        </Modal.Body>
       
        <Modal.Footer>
            <button className="btn btn-primary" onClick={()=>{Aceptar();}}>Aceptar</button>
            <button className="btn btn-primary" onClick={()=>SetActivoPreAlerta(false)}>Cerrar</button>
        </Modal.Footer>
    </Modal>
    )
}

export function ActivarRedireccion()
{
    const {Redireccion,SetRedireccion}=useContext(MensajeContActualizacion)
    const desactivar=()=>
    {
        SetRedireccion(false);
    }
    return(
        <Modal show={Redireccion}>
        
        <Modal.Body style={{borderColor:"#bce8f1"}}>
            <div className="panel panel-info" style={{padding:"10px 15px",borderBottom:"1px solid trasparent",borderTopRightRadius:"3px",borderTopLeftRadius:"3px",color:"#31708f",backgroundColor:"#d9edf7",borderColor:"#bce8f1"}}>
                <label style={{display:"inline-block",marginBottom:"5px",fontWeight:"700"}}>
                    ¿Desea visitar la pagina eShopex?
                </label>
            </div>
            
        </Modal.Body>
        <Modal.Header style={{marginBottom:"20px",padding:"10px 15px",color:"#31708f",backgroundColor:"#fff",borderColor:"#bce8f1",border:"1px solid transparent",borderRadius:"4px",display:"block"}}>
            
        </Modal.Header >
        <Modal.Footer>
        <button className="btn btn-success" onClick={()=>{desactivar()}}>Mantenerme en la cuenta</button>
        <button className="btn btn-danger" onClick={()=>{window.location.href="https://eshopex.cl/"}}>Ir a la pagina eShopex</button>
            
        </Modal.Footer>
    </Modal>
    )
}

export function MensajeGoogle()
{
    const [activo,SetActivo]=useState<boolean>()
    const {MensajeEmergenteGoogle,SetMensajeEmergenteGoogle}=useContext(MensajeContActualizacion)

    const key=(e:any)=>
    {
      if (e.key === 'Enter') {
        desactivar()
      }
    }
    useEffect(()=>
    {
        if(MensajeEmergenteGoogle!="")
        {
            SetActivo(true)
        }
    })

    const desactivar=()=>
    {
        SetActivo(false);
        SetMensajeEmergenteGoogle("");
    }
    return (
    <>
    
    <Modal show={activo} tabIndex={0} onKeyDown={key}>
        
        <Modal.Body style={{borderColor:"#bce8f1"}}>
            <div className="panel panel-info" style={{padding:"10px 15px",borderBottom:"1px solid trasparent",borderTopRightRadius:"3px",borderTopLeftRadius:"3px",color:"#31708f",backgroundColor:"#d9edf7",borderColor:"#bce8f1"}}>
                <label style={{display:"inline-block",marginBottom:"5px",fontWeight:"700"}}>
                    {MensajeEmergenteGoogle}
                    <p >Puedes crear tu cuenta <a href="https://eshopex.cl/registro.aspx?VarUrl=STD_CL" style={{textDecoration:"none",color:"#f98824"}}>Aquí</a></p>
                </label>
            </div>
        </Modal.Body>
        <Modal.Header style={{marginBottom:"20px",padding:"10px 15px",color:"#31708f",backgroundColor:"#fff",borderColor:"#bce8f1",border:"1px solid transparent",borderRadius:"4px",display:"block"}}>
        
        </Modal.Header >
        <Modal.Footer>
            <button className="btn btn-warning"  onClick={()=>desactivar()}>Cerrar</button>
        </Modal.Footer>
    </Modal>
   
    </>)
}
export function MensajeEliminarPreAlerta()
{
    const {ElimnarPrealertas,SetElimnarPrealertas,Id,SetId,SetLoading}=useContext(MensajeContActualizacion)
    const {tok}=useContext(tokens)
    useEffect(()=>
    {
        if(Id!=0)
        {
            SetElimnarPrealertas(true)
        }else
        {
            SetElimnarPrealertas(false)
        }
    },[Id])

    const eliminar=()=>
    {
        SetLoading(true)
        const datos=GetSinRetorno(VendemosContigo.Eliminacion.replace("@id",Id),"application/json",tok)
        SetId(0)
        SetLoading(false)
    }
    return(
        <Modal show={ElimnarPrealertas}>
        
        <Modal.Body style={{borderColor:"#bce8f1"}}>
            <div className="panel panel-info" style={{padding:"10px 15px",borderBottom:"1px solid trasparent",borderTopRightRadius:"3px",borderTopLeftRadius:"3px",color:"#31708f",backgroundColor:"#d9edf7",borderColor:"#bce8f1"}}>
                <label style={{display:"inline-block",marginBottom:"5px",fontWeight:"700"}}>
                    ¿Desea Eliminar esta prealerta?
                </label>
            </div>
            
        </Modal.Body>
        <Modal.Header style={{marginBottom:"20px",padding:"10px 15px",color:"#31708f",backgroundColor:"#fff",borderColor:"#bce8f1",border:"1px solid transparent",borderRadius:"4px",display:"block"}}>
            
        </Modal.Header >
        <Modal.Footer>
            {/* ordenar */}
        <button className="btn btn-danger" onClick={()=>{eliminar();SetElimnarPrealertas(false)}}>Si</button>
        <button className="btn btn-success" onClick={()=>{SetId(0);SetElimnarPrealertas(false)}}>No</button>
            
        </Modal.Footer>
    </Modal>
    )
}